import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";
import { SystemParameterFetchRequest, SystemParameterReduxTypes, SystemParameterUpdateRequest, FetchSystemParameterByIdRequest } from "./types";
import {
  fetchSystemParametersApi,
  fetchSystemParameterByIdApi,
  updateSystemParameterApi,
  fetchSystemParameterVersionApi,
  fetchSystemParameterLatestVersionApi,
  fetchSystemParameterVersionDetailsApi,
  approveSystemParameterApi,
  rejectSystemParameterApi
} from "./api";

function* fetchSystemParameters({ payload, type }: SystemParameterFetchRequest): SagaIterator {
  try {
    const response = yield call(fetchSystemParametersApi, payload);
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchSystemParameterByID({ payload, type }: FetchSystemParameterByIdRequest): SagaIterator {
  try {
    const response = yield call(fetchSystemParameterByIdApi, payload);
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID_ERROR,
      payload: { error: error }
    });
  }
}

function* updateSystemParameter({ payload, type }: SystemParameterUpdateRequest): SagaIterator {
  try {
    const response = yield call(updateSystemParameterApi, payload);
    yield put({
      type: SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER_SUCCESS,
      payload: {
        data: {
          ...response.data.data,
          draft: payload.draft
        }
      }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchSystemParameterVersion({ payload, type }: FetchSystemParameterByIdRequest): SagaIterator {
  try {
    const response = yield call(fetchSystemParameterVersionApi, payload);
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchSystemParameterLatestVersion({ payload, type }: FetchSystemParameterByIdRequest): SagaIterator {
  try {
    const response = yield call(fetchSystemParameterLatestVersionApi, payload);
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION_ERROR,
      payload: { error: error }
    });
  }
}

function* fetchSystemParameterVersionDetails({ payload, type }: FetchSystemParameterByIdRequest): SagaIterator {
  try {
    const response = yield call(fetchSystemParameterVersionDetailsApi, payload);
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS_ERROR,
      payload: { error: error }
    });
  }
}

function* approveSystemParameter({ payload, type }: any): SagaIterator {
  try {
    const response = yield call(approveSystemParameterApi, payload);
    yield put({
      type: SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER_ERROR,
      payload: { error: error }
    });
  }
}

function* rejectSystemParameter({ payload, type }: any): SagaIterator {
  try {
    const response = yield call(rejectSystemParameterApi, payload);
    yield put({
      type: SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER_ERROR,
      payload: { error: error }
    });
  }
}

export function* watchFetchSystemParameters() {
  yield takeEvery(SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETERS, fetchSystemParameters);
}
export function* watchFetchSystemParameterById() {
  yield takeEvery(SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_BY_ID, fetchSystemParameterByID);
}
export function* watchUpdateSystemParameter() {
  yield takeEvery(SystemParameterReduxTypes.UPDATE_SYSTEM_PARAMETER, updateSystemParameter);
}
export function* watchFetchSystemParameterVersion() {
  yield takeEvery(SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION, fetchSystemParameterVersion);
}
export function* watchFetchSystemParameterLatestVersion() {
  yield takeEvery(SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_LATEST_VERSION, fetchSystemParameterLatestVersion);
}
export function* watchFetchSystemParameterVersionDetails() {
  yield takeEvery(SystemParameterReduxTypes.FETCH_SYSTEM_PARAMETER_VERSION_DETAILS, fetchSystemParameterVersionDetails);
}
export function* watchApproveSystemParameter() {
  yield takeEvery(SystemParameterReduxTypes.APPROVE_SYSTEM_PARAMETER, approveSystemParameter);
}
export function* watchRejectSystemParameter() {
  yield takeEvery(SystemParameterReduxTypes.REJECT_SYSTEM_PARAMETER, rejectSystemParameter);
}
function* systemParameterSaga() {
  yield all([
    fork(watchFetchSystemParameters),
    fork(watchFetchSystemParameterById),
    fork(watchUpdateSystemParameter),
    fork(watchFetchSystemParameterVersion),
    fork(watchFetchSystemParameterLatestVersion),
    fork(watchFetchSystemParameterVersionDetails),
    fork(watchApproveSystemParameter),
    fork(watchRejectSystemParameter)
  ]);
}

export default systemParameterSaga;
